export enum PageEnum {
  ORGANIZATION = "ORGANIZATION",
  USER = "USER",
  BIM_PROJECT = "BIM_PROJECT",
  RSEE = "RSEE",
  MATERIAL_LIB = "MATERIAL_LIB",
}
